var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"justify-content-md-center text-center"},[_c('b-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"text-center center-item"},[_c('b-img',{attrs:{"src":this.qrcode}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }